import { useState } from "react";
import { Crosshair, X } from "lucide-react";
import { toast } from "sonner";
import { VenueMap } from "@/components/VenueMap";
import { VenueCard } from "@/components/VenueCard";
import { SearchPanel } from "@/components/SearchPanel";
import { ResultsState } from "@/components/ResultsState";
import { useSearch } from "@/context/SearchContext";
import { isLive } from "@/lib/hh";

export default function MapPage() {
  const { venues, origin } = useSearch();
  const [selectedId, setSelectedId] = useState(null);
  const selected = venues.find((v) => v.id === selectedId);

  const nearMe = () => {
    const open = venues.filter((v) => isLive(v)).sort((a, b) => (a.distance ?? 0) - (b.distance ?? 0));
    if (!open.length) {
      toast("No happy hours are open right now nearby");
      return;
    }
    setSelectedId(open[0].id);
  };

  return (
    <div className="page">
      <SearchPanel />
      <div className="mt-6">
        {!venues.length ? (
          <ResultsState />
        ) : (
          <div className="relative">
            <VenueMap venues={venues} origin={origin} selectedId={selectedId} onSelect={setSelectedId} className="h-[70vh] min-h-[420px]" />
            <button
              data-testid="map-near-me-button"
              onClick={nearMe}
              className="absolute right-3 top-3 z-[500] flex items-center gap-2 rounded-full bg-[#fde68a] px-4 py-2.5 text-sm font-bold text-zinc-950 shadow-lg hover:bg-yellow-200"
            >
              <Crosshair size={16} /> Near Me · Open Now
            </button>
            {selected && (
              <div data-testid="map-selected-card" className="absolute inset-x-3 bottom-3 z-[500] sm:left-auto sm:right-3 sm:w-96">
                <button data-testid="map-close-card" onClick={() => setSelectedId(null)} aria-label="Close" className="absolute -top-3 right-3 z-10 flex h-8 w-8 items-center justify-center rounded-full border border-zinc-700 bg-zinc-900 text-zinc-300">
                  <X size={15} />
                </button>
                <div className="max-h-[55vh] overflow-y-auto rounded-2xl shadow-2xl">
                  <VenueCard venue={selected} />
                </div>
              </div>
            )}
          </div>
        )}
        <p className="mt-3 text-xs text-zinc-500">Bright pins are open now, gold pins are Featured, grey pins are closed. Blue dot is your search spot.</p>
      </div>
    </div>
  );
}
